export default __webpack_public_path__ + "static/Plots0074-317109966e5e646d5dc0db82d1dd78ce.jpg";